import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { instagramIcon, facebookIcon, twitterIcon } from '../assets';
import '../Styles/css/Footer.css';

export default class Footer extends Component {

    render() {

        return (
            <div className="Footer">
                <div className="left">
                    <Link to="/" onClick={this.closeNav}>FLAURAL</Link>
                </div>
                <div className="right">
                    <a href="https://www.instagram.com/flauralmusic/" target="_blank" rel="noopener noreferrer" alt="instagram" title="Instagram"><img src={instagramIcon} alt="Instagram" /></a>
                    <a href="https://www.facebook.com/flauralmusic/" target="_blank" rel="noopener noreferrer" alt="facebook" title="Facebook"><img src={facebookIcon} alt="Facebook" /></a>
                    <a href="https://twitter.com/flauralmusic?lang=en" target="_blank" rel="noopener noreferrer" alt="twitter" title="Twitter"><img src={twitterIcon} alt="Twitter" /></a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Footer.js